import { Controller } from "stimulus"
import { FetchResponseError, handleError } from "../utils/errors"
import fetchWithCSRF from "../utils/fetch_with_csrf"
import { isSignedOut } from "../utils/session"

export default class extends Controller {
  static targets = ["fragment"]
  static values = {
    url: String,
    wait: Boolean,
    loadOnce: Boolean,
    loaded: Boolean,
    sessionRequired: Boolean,
  }

  connect() {
    if (this.waitValue) return
    if (this.loadOnceValue && this.loadedValue) return
    if (this.sessionRequiredValue && isSignedOut()) return

    this.load()
  }

  loadFromElement(e) {
    this.load(e.target.href || e.target.value)
    this.element.dataset.loading = "true"
    e.preventDefault()
  }

  load(url = this.urlValue) {
    if (this.abortController) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    fetchWithCSRF(url, { signal: this.abortController.signal })
      .then((response) => this._responseTextIfOk(response))
      .then((html) => this._setContent(html))
      .catch((error) => handleError(error))
  }

  _setContent(html) {
    let targetArea = this.element

    if (this.hasFragmentTarget) {
      targetArea = this.fragmentTarget
    }

    targetArea.innerHTML = html
    this.loadedValue = true
    delete this.element.dataset.loading
  }

  _responseTextIfOk(response) {
    if (this.abortController) {
      delete this.abortController
    }
    if (response.ok) {
      return response.text()
    } else {
      throw new FetchResponseError(response)
    }
  }
}
